import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import CheckIcon from '@material-ui/icons/Check';
import LanguageIcon from '@material-ui/icons/Language';
import { dealTokens, SystemButton } from 'components/shared';

// The languages the Deal app ships, each listed by its own name. No flags: they stand for
// countries, not languages, and render inconsistently (Windows shows two letters instead).
const LANGUAGES = [
  { code: 'en', name: 'English' },
  { code: 'it', name: 'Italiano' },
  { code: 'de', name: 'Deutsch' },
];

const LanguagePicker = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const current = LANGUAGES.find(({ code }) => i18n.language?.startsWith(code)) || LANGUAGES[0];

  const handleClick = event => {
    if (anchorEl) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = lang => {
    if (lang) {
      localStorage.setItem('language', lang);
      i18n.changeLanguage(lang);
    }
    setAnchorEl(null);
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: '8px',
        right: '8px',
        width: 'auto',
        zIndex: 2000,
      }}
    >
      {/* The trigger shows the active language, so it can be read without opening the menu. */}
      <SystemButton
        variant="ghost"
        size="sm"
        icon={<LanguageIcon />}
        onClick={handleClick}
        aria-haspopup="menu"
        aria-label={current.name}
        style={{ background: dealTokens.color.surface, textTransform: 'uppercase', letterSpacing: 0.5 }}
      >
        {current.code}
      </SystemButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={() => handleClose(null)}
        PaperProps={{ style: { marginTop: 6, minWidth: 180, borderRadius: dealTokens.radius.md, border: `1px solid ${dealTokens.color.border}` } }}
        MenuListProps={{ style: { padding: 4 } }}
      >
        {LANGUAGES.map(({ code, name }) => {
          const active = code === current.code;
          return (
            <MenuItem
              key={code}
              selected={active}
              onClick={() => handleClose(code)}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: dealTokens.space[4],
                borderRadius: dealTokens.radius.sm,
                fontSize: 14,
                fontWeight: active ? dealTokens.font.weightSemibold : dealTokens.font.weightRegular,
                color: active ? dealTokens.color.primary : dealTokens.color.text,
                // Only the active row gets a background — an inline one on the others would
                // override MUI's hover highlight.
                ...(active && { backgroundColor: dealTokens.color.primarySoft }),
              }}
            >
              {name}
              {active && <CheckIcon style={{ fontSize: 16 }} />}
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
};

export default LanguagePicker;
